// extracted by css-extract-rspack-plugin
export default {"cls1":"AnalyticsV2NavBar-cls1_uNS","cls2":"AnalyticsV2NavBar-cls2_MWA AnalyticsV2NavBar-cls1_uNS"};